import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import moment from 'moment'
import VueGtag from "vue-gtag";
import axios from 'axios'

import session, { setStore } from '@/api/session';
import { TOKEN_STORAGE_KEY } from '@/config/runtime';

import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false

const token = localStorage.getItem(TOKEN_STORAGE_KEY)
if (token) {
  axios.defaults.headers.common['Authorization'] = `Token ${token}`
  session.defaults.headers.Authorization = `Token ${token}`
}

setStore(store);

new Vue({
  vuetify,
  router,
  store,
  beforeCreate() {
    this.$store.dispatch('dataTable/loadStateFromStorage');
  },
  moment,
  render: h => h(App)
}).$mount('#app')

// GTAG — enabled whenever a measurement ID is configured.
// Gating on NODE_ENV === 'production' broke custom build modes
// (e.g. `--mode email_only`) because Vue CLI only auto-sets
// NODE_ENV=production for the built-in "production" mode.
// The env var alone is the right switch: set in .env.production,
// .env.test, and .env.email_only; absent in .env.development.
if (process.env.VUE_APP_GTAG_ID) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GTAG_ID }
  }, router);
}
